// React & Nextjs imports
import React from "react";
import Image from "next/image";

// Hooks & Utils
import useMobile from "@/app/hooks/use-mobile";

// Components
import { UsStock } from "@/app/interface/global";
import { toTitleCase } from "@/app/utils/helper";

interface Props {
    stockDetails: UsStock;
}

const AssetName: React.FC<Props> = ({ stockDetails }) => {
    const { isMobile } = useMobile();

    return (
        <div className="flex flex-col gap-4 bg-white pb-6 pt-6 sm:container sm:flex-row md:flex-row md:items-center md:py-0 md:pb-10 md:pt-10">
            <div className="mb-1 h-[48px] w-[48px] flex-shrink-0 animate-pulse overflow-hidden rounded-sm bg-gray-100 md:mb-0 md:h-[80px] md:w-[80px] md:rounded-lg">
                <Image
                    src={stockDetails?.company_logo}
                    alt={`Image of ${stockDetails?.company_name}`}
                    width={isMobile ? 48 : 80}
                    height={isMobile ? 48 : 80}
                    className="max-h-[80px] min-h-[48px] min-w-[48px] max-w-[80px] rounded-sm object-cover opacity-0 transition-all duration-200 md:min-h-[80px] md:min-w-[80px] md:rounded-[11.43px]" /* border-[1px] border-neutralOpacityDark-10 */
                    onLoad={(obj) => {
                        obj.currentTarget.classList.add("opacity-100");
                        if (obj.currentTarget.parentElement?.classList) {
                            obj.currentTarget.parentElement.classList.remove("animate-pulse");
                        }
                    }}
                />
            </div>
            <div className="flex flex-col">
                <h1 className="mb-0.5 text-4xl font-semibold leading-[120%] tracking-[-1%] sm:text-5xl md:mb-0 md:leading-[130%]">
                    {stockDetails?.company_name}
                </h1>
                <p className="mt-0.5 text-sm font-medium tracking-[-1%] text-[#0F1016] md:mt-0 md:text-lg md:leading-[164%]">
                    {`NASDAQ: ${stockDetails.symbol}`}
                    <span className="mx-3 inline-block text-center">|</span>
                    {`${toTitleCase(stockDetails.company_fundamentals.market_cap_category.replaceAll("-", " "))}`}
                    {/* <span className="mx-3 inline-block text-center">|</span>
                    {`${stockDetails.company_profile.sector}`} */}
                </p>
            </div>
        </div>
    );
};

export default AssetName;
